<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
export default {
  name: "App",
  components: {
    Footer,
    Header,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="less">
@import url(./assets/common.css);
@import url(./assets/swiper.min.css);
@font-face {
  font-family: "HM"; /* 自定义字体名称 */
  src: url("@/assets/fonts/HarmonyOS_Sans_SC_Regular.ttf");
}
html {
  font-family: "Microsoft YaHei", "Arial";
}
body {
  font-size: 16px;
}
.wrap {
  width: 1250px;
  margin: 0 auto;
}
.check-more {
  font-size: 14px;
  color: #d40a2a;
  text-align: right;
  cursor: pointer;
}
// #app {
//   min-height: 100vh;
//   background: url(./assets/webbg.png) center center no-repeat;
//   background-size: cover;
//   background-attachment: fixed;
// }
@keyframes seamless-scrolling {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-80%);
  }
}
@media screen and (max-width: 1024px) {
  html {
    width: 100%;
    height: auto;
  }

  body {
    width: 100%;
    min-height: 100%;
    overflow-x: clip;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: auto;
  }

  #app {
    width: 100%;
    max-width: 100vw;
    overflow-x: clip;
  }

  .wrap {
    width: 100%;
    max-width: 100%;
    padding: 0 12px;
    box-sizing: border-box;
  }

  .breadcrumb {
    font-size: 12px;
    margin-bottom: 10px;
    line-height: 1.6;
    word-break: break-all;

    a {
      font-size: 12px;
    }
  }

  .mainbox {
    max-width: 100%;
    overflow-x: clip;
  }

  .pagination {
    margin-top: 20px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .el-pagination {
    flex-wrap: wrap;
    justify-content: center;
    padding: 0 4px;
  }

  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .el-pager li {
    min-width: 28px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
  }
}
</style>
